module.exports = __webpack_public_path__ + "static/media/logo_arousa_norte.cfac4d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo_arousa_norte.png
// module id = 349
// module chunks = 0